import React from 'react'
import styles from "../../pages/pages.module.scss";
import { securitynote } from "../../utils/assets"
import FrameCard from '../CommonCard';

const SecuritySection = () => {
  return (
    <section className="container pt-0">

      {/* <div className={`${styles.floatImage}`}>
          <img src={assets.secimg} alt="Security Image" />
        </div> */}

      <div className="row">
        <div className={`mb-5 ${styles.sectionheading}`}>
          <h3>Trust & Security</h3>
          <p>Data security and privacy are our top priorities</p>
        </div>
      </div>

      <div className="g-4 justify-content-center mx-2 mx-md-0 row text-center">
        {securitynote.map((item, index) => (
          <div key={index} className="col-lg-4 col-md-6 col-sm-12">

            <FrameCard>
              <div className={styles.securitynotes}>
                <img src={item.icon} alt="" />
                <h6>{item.text}</h6>
                <p>{item.content}</p>
              </div>
            </FrameCard>

          </div>
        ))}
      </div>

    </section>
  )
}

export default SecuritySection;